module.exports = __webpack_public_path__ + "static/media/storePurchase_35_50.096a349e.png";